import { useTranslation } from "react-i18next";

export default function FeatureStory() {
  const { t } = useTranslation();

  return (
    <section id="about" className="relative w-full py-20 md:py-28 bg-background-100 overflow-hidden">
      {/* Decorative line */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-16 bg-primary-400"></div>

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Image */}
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] rounded-lg overflow-hidden border border-background-300/70">
              <img
                src="https://storage.readdy-site.link/project_files/d7d49463-cb3a-4e17-bed8-14db381c2d7e/f0e37f37-9ef5-43b7-8acc-b5d1f247c7b3_compressed_hero-brand-conference-auditorium-copy.webp"
                alt="李家超 香港特區行政長官"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-accent-500 hidden md:flex flex-col items-center justify-center text-background-50 rounded-lg">
              <span className="font-heading font-black text-4xl">05</span>
              <span className="text-xs tracking-widest">{t("feature.date.label")}</span>
              <span className="text-[10px] tracking-widest mt-1">{t("feature.date.location")}</span>
            </div>
          </div>

          {/* Text */}
          <div className="lg:col-span-7">
            <div className="text-primary-600 text-xs md:text-sm tracking-[0.3em] font-medium mb-4">
              {t("feature.label")}
            </div>
            <h2 className="font-heading font-bold text-foreground-950 text-3xl md:text-4xl lg:text-5xl leading-tight mb-6">
              {t("feature.title.part1")}
              <br />
              <span className="text-primary-700">{t("feature.title.part2")}</span>
            </h2>
            <div className="space-y-4 text-foreground-700 text-base md:text-lg leading-relaxed">
              <p>{t("feature.p1")}</p>
              <p>{t("feature.p2")}</p>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-6 pt-8 border-t border-background-300/70">
              <div>
                <div className="font-heading font-bold text-3xl md:text-4xl text-primary-700">十五五</div>
                <div className="text-xs md:text-sm text-foreground-600 mt-1 tracking-wider">{t("feature.stat.1.label")}</div>
              </div>
              <div>
                <div className="font-heading font-bold text-3xl md:text-4xl text-primary-700">2</div>
                <div className="text-xs md:text-sm text-foreground-600 mt-1 tracking-wider">{t("feature.stat.2.label")}</div>
              </div>
              <div>
                <div className="font-heading font-bold text-3xl md:text-4xl text-primary-700">100+</div>
                <div className="text-xs md:text-sm text-foreground-600 mt-1 tracking-wider">{t("feature.stat.3.label")}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}